import axios from "axios";
import { API_BASE_URL,API_PREFIX, STORAGE_KEYS } from "../constants/config";

const API_URL = `${API_BASE_URL}${API_PREFIX}`;
const getAuthHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem(STORAGE_KEYS.TOKEN)}`,
  "X-Authenticated-User": localStorage.getItem(STORAGE_KEYS.USERNAME),
});

export const auditService = {
  updateBillWithItems: async (billId, items) => {
    const response = await axios.put(
      `${API_URL}/audit/v1/distributors/bills/${billId}/items`,
      items,
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  calculateProfitByDate: async (fromDate, toDate) => {
    const response = await axios.get(
      `${API_URL}/audit/v1/distributors/profit?fromDate=${fromDate}&toDate=${toDate}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  calculateTotalInvestment: async () => {
    const response = await axios.get(`${API_URL}/audit/v1/distributors/investment/total`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  calculateMedicineWiseInvestment: async (page = 0, size = 15) => {
    const response = await axios.get(
      `${API_URL}/audit/v1/distributors/investment/medicine-wise?page=${page}&size=${size}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  getAuditSummary: async (startDate, endDate) => {
    const response = await axios.get(
      `${API_URL}/audit/summary?startDate=${startDate}&endDate=${endDate}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  },
};

export const reportService = {
  generateSellReport: async (startDate, endDate) => {
    const response = await axios.get(
      `${API_URL}/report/sell?startDate=${startDate}&endDate=${endDate}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  generatePurchaseReport: async (startDate, endDate) => {
    const response = await axios.get(
      `${API_URL}/report/purchase?startDate=${startDate}&endDate=${endDate}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  generateSummaryReport: async (startDate, endDate) => {
    const response = await axios.get(
      `${API_URL}/report/summary?startDate=${startDate}&endDate=${endDate}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  },
};

export const gstReportService = {
  getGstReport: async (startDate, endDate) => {
    const response = await axios.get(
      `${API_URL}/order/report/gst?startDate=${startDate}&endDate=${endDate}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  getGstSummary: async (startDate, endDate, includeCancel = false) => {
    const response = await axios.get(
      `${API_URL}/order/report/gst/summary?startDate=${startDate}&endDate=${endDate}&includeCancel=${includeCancel}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  getGstSales: async (startDate, endDate, includeCancel = false, page = 0, size = 50) => {
    const response = await axios.get(
      `${API_URL}/order/report/gst/sales?startDate=${startDate}&endDate=${endDate}&includeCancel=${includeCancel}&page=${page}&size=${size}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  getGstPurchases: async (startDate, endDate, page = 0, size = 50) => {
    const response = await axios.get(
      `${API_URL}/order/report/gst/purchases?startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  getGstReturns: async (startDate, endDate, includeCancel = false, page = 0, size = 50) => {
    const response = await axios.get(
      `${API_URL}/order/report/gst/returns?startDate=${startDate}&endDate=${endDate}&includeCancel=${includeCancel}&page=${page}&size=${size}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  getGstHsnSummary: async (startDate, endDate, includeCancel = false) => {
    const response = await axios.get(
      `${API_URL}/order/report/gst/hsn-summary?startDate=${startDate}&endDate=${endDate}&includeCancel=${includeCancel}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  downloadGstReportPdf: async (startDate, endDate, includeCancel = false) => {
    const response = await axios.get(
      `${API_URL}/order/report/gst/pdf?startDate=${startDate}&endDate=${endDate}&includeCancel=${includeCancel}`,
      { headers: { ...getAuthHeaders() }, responseType: "blob" }
    );
    return response.data;
  },

  downloadGstReportExcel: async (startDate, endDate, includeCancel = false) => {
    const response = await axios.get(
      `${API_URL}/order/report/gst/excel?startDate=${startDate}&endDate=${endDate}&includeCancel=${includeCancel}`,
      { headers: { ...getAuthHeaders() }, responseType: "blob" }
    );
    return response.data;
  },
};

export const billService = {
  generateBillByOrderId: async (orderId) => {
    const response = await axios.get(`${API_URL}/order/bill/${orderId}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  generateBillByDate: async (date) => {
    const response = await axios.get(`${API_URL}/order/bill/date?date=${date}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  downloadBillPDF: async (orderId) => {
    const response = await axios.get(`${API_URL}/order/bill/${orderId}/pdf`, {
      headers: { ...getAuthHeaders(), "Content-Type": "application/pdf" },
      responseType: "blob",
    });
    return response.data;
  },

  downloadBillExcel: async (orderId) => {
    const response = await axios.get(`${API_URL}/order/bill/${orderId}/excel`, {
      headers: { ...getAuthHeaders(), "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" },
      responseType: "blob",
    });
    return response.data;
  },
};
